<div class="dialog-container">
    <div class="dialog-header">
        <span><b>WELCOME TO PROPERTY MATRIX!</b></span>
        <button (click)="closeDialog()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div class="dialog-content">
        <div>
            <b>This domain is not open to the public yet.</b><br><br>
            Are you a <b>Broker/Agent</b> or <b>Network Planner</b>?<br>
            To get started, tap the <mat-icon aria-label="Side nav toggle icon" class="icon-align">menu</mat-icon> menu
            at the top right
            and select "Register".<br>
            Agents: Your principal needs to register first.<br><br>
            <b>Need help? Reach out anytime!</b><br>
            Email our liaison manager at <a href="mailto:relations@propertymatrix.co.za"
                class="email-address">relations@propertymatrix.co.za</a> — we're here to assist.
        </div>
        <button mat-button (click)="closeDialog()" class="got-it-button">
            Got It
        </button>
    </div>
</div>